import { render, staticRenderFns } from "./ArchievedRequests.vue?vue&type=template&id=10ba40cc&"
import script from "./ArchievedRequests.vue?vue&type=script&lang=js&"
export * from "./ArchievedRequests.vue?vue&type=script&lang=js&"
import style0 from "./ArchievedRequests.vue?vue&type=style&index=0&id=10ba40cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports